module.exports = __webpack_public_path__ + "static/media/logo-branca.95192545.png";